// AboutMe.js

import React from "react";
import "./About.css";

const AboutMe = () => {
  return (
    <div className="about-me-container">
      <h1>About Me - Web Developer</h1>
      <p>
        Hello! I'm shahbaz, a passionate web developer with expertise in
        crafting engaging and responsive user experiences. I specialize in
        utilizing modern web technologies to bring ideas to life.
      </p>

      <p>
        My skills include proficiency in <span className="highlight">HTML</span>
        , <span className="highlight">CSS</span>,{" "}
        <span className="highlight">JavaScript</span>,
        <span className="highlight">React</span>,{" "}
        <span className="highlight">NextJs</span>,
        <span className="highlight">NodeJs</span>,{" "}
        <span className="highlight">PHP</span>, and{" "}
        <span className="highlight">Laravel</span>. I am also experienced in
        developing mobile applications using{" "}
        <span className="highlight">React Native</span>. My journey in web
        development has allowed me to work with various projects, from creating
        stunning websites to developing cross-platform mobile applications.
      </p>

      <p>
        Previously, I had the privilege of contributing to the success of a
        dynamic company like <span className="highlight">Zera Creative</span>,
        where I honed my skills and collaborated with a talented team of
        professionals in the field of web development.
      </p>

      <p>
        I am passionate about staying updated with the latest trends and
        technologies in the ever-evolving web development landscape. My goal is
        to create seamless and visually appealing digital experiences that make
        a positive impact.
      </p>

      <p>Let's connect and bring your digital vision to life together!</p>
    </div>
  );
};

export default AboutMe;
